export const environment = {
  baseUrl: 'https://quiz.staging-usc1.aodocs.app',
  apiUrl: '/_ah/api/',
  aodocsUrl: 'https://staging-usc1.aodocs.app/',
  clientId: '374815658688-76vjideo6cbqtmvk47jv8kbpkdiitkb3.apps.googleusercontent.com',
  version: '1.0.0',
  production: true
};
